import { useJsApiLoader, GoogleMap, Marker, DirectionsRenderer } from '@react-google-maps/api';
import { googleApiKey } from '../utils/config';
import { useEffect, useMemo, useState } from 'react';
import navIcon from '../assets/navigation.png';
import { url } from '../utils/config';
import axios from 'axios';
import DelayModal from './DelayModal';
import { useRecoilState } from 'recoil';
import clientstateAtom from '../atoms/clientsStateAtom';
import locationStateAtom from '../atoms/locationStateAtom';
import appointmentDetailsAtom from '../atoms/appointmentDetailsAtom';
import ConfirmationModal from './ConfirmationModal';
import { btnOne, btnRound, label, subTitle, title } from '../utils/style';
import arrowBlack from '../assets/icons/arrow_black.png'
import carIcon from '../assets/icons/car-icon.png'
import locationTimerAtom from '../atoms/locationTimerAtom';
import user from '../assets/icons/seller.png';
import technician from '../assets/icons/technician.png';

function Map(props) {
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: googleApiKey
    })
    const google = window.google;



    const [ clients, setClients ] = useRecoilState(clientstateAtom)
    const [ appointmentDetails, setAppointmentDetails ] = useRecoilState(appointmentDetailsAtom);
    const [ directionsResponse, setDirectionsResponse ] = useState()
    const [ distance, setDistance ] = useState()
    const [ duration, setDuration ] = useState()
    const [ showMap, setShowMap ] = useState(true)
    const [ navigating, setNavigating ] = useState(false)
    const [ timer, setTimer ] = useState()
    const [ showDelayModal, setShowDelayModal ] = useState(false)
    const [ myLocation, setMyLocation ] = useRecoilState(locationStateAtom)
    const [ showConfirmationModal, setShowConfirmationModal ] = useState(false)
    const [ locationTimer, setLocationTimer ] = useRecoilState(locationTimerAtom);

        

    useMemo(() => {
        calculateRoute()
    }, [myLocation])

    async function calculateRoute() {
        try {
            console.log('Starting routing')
            console.log(myLocation)
            console.log(props)
            const directionsService = new google.maps.DirectionsService();
            const result = await directionsService.route({
                origin: `${myLocation.latitude},${myLocation.longitude}`,
                destination: `${+props.lat},${+props.lng}`,
                travelMode: 'DRIVING'
            })
        setDirectionsResponse(result);
        setDistance(result.routes[0].legs[0].distance.text);
        setDuration(result.routes[0].legs[0].duration.text);
        } catch (error) {
            console.log(error);
        }
    }

    async function streamLocation() {
        try {
            const { id, userId } = props;
            const status = 'On the way'
            const reqUrl = url + '/booking_status';
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const data = await axios.patch(reqUrl, {id, userId, status}, { headers });
            setClients([{id: props.userId, type: 'customer'}])
            setNavigating(true);
        } catch (error) {
            console.log(error)
        }
    }

    async function stopLocationStreaming() {
        try {
            const { id, userId } = props;
            const status = 'Reached'
            const reqUrl = url + '/booking_status';
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const data = await axios.patch(reqUrl, {id, userId, status}, { headers });
            const details = JSON.parse(JSON.stringify(appointmentDetails));
            details.status = status;
            setAppointmentDetails(details)
            setClients([])
            setNavigating(false);
            clearInterval(locationTimer)
            props.setShowModal(false)
        } catch (error) {
            console.log(error)
        }
    }

    async function cancelTrip() {
        try {
            const { id, userId } = props;
            const status = 'Assigned'
            const reqUrl = url + '/booking_status';
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const data = await axios.patch(reqUrl, {id, userId, status}, { headers });
            const details = JSON.parse(JSON.stringify(appointmentDetails));
            details.status = status;
            setClients([])
            setNavigating(false);
            clearInterval(locationTimer)
        } catch (error) {
            console.log(error)
        }
    }


    return(
        <div className="flex justify-center items-center bg-black fixed top-0 pt-12 left-0 h-screen w-screen bg-opacity-60">
            <div className="h-full w-full rounded-md bg-white py-2 scroll-auto">
                {
                    showConfirmationModal && 
                    <ConfirmationModal 
                        header={'Start Navigation'}
                        body={'Do you want to start navigation?'}
                        cancelHandler={setShowConfirmationModal}
                        confirmHandler={() => streamLocation()}
                        confirmText={'Start'}
                    />  
                }
                {
                    showDelayModal && <DelayModal setShowModal={setShowDelayModal} userId={props.userId} />
                }
                <div className='h-3/4'>
                    {
                        !isLoaded ? 'Unable to load Map.!' : 
                            <GoogleMap 
                                center={{lat: myLocation.latitude, lng: myLocation.longitude}} 
                                zoom={10} 
                                mapContainerStyle={{width: '100%', height: '100%'}} 
                                options={{
                                    mapTypeControl: false,
                                    streetViewControl: false,
                                    fullscreenControl: false,
                                }}
                            >
                                {
                                    directionsResponse && 
                                    <Marker 
                                        position={{lat: +props.lat, lng: +props.lng}} 
                                        icon={{url: user, scaledSize: new window.google.maps.Size(40,40)}}
                                    />
                                }
                                 {
                                    directionsResponse &&
                                    <Marker 
                                        position={{lat: myLocation.latitude, lng: myLocation.longitude}} 
                                        icon={{url: technician, scaledSize: new window.google.maps.Size(40,40)}}
                                    />
                                 }
                                {directionsResponse && <DirectionsRenderer directions={directionsResponse} options={{suppressMarkers: true}}/>}
                            </GoogleMap>
                    }
                    {
                        !showMap && 
                        <div className="flex flex-col py-6 px-2 bg-customTwo fixed top-12 left-0 right-0 h-3/4 max-h-3/4 w-screen overflow-scroll">
                           {
                                directionsResponse && directionsResponse.routes[0].legs[0].steps.map((step, ind) => 
                                <div className='w-full flex gap-4 px-2 mb-1' key={ind}>
                                    <div className='flex flex-col justify-center items-center h-full'>
                                        <div className='w-2 h-2 mt-3 rounded-full bg-customOne'></div>
                                        <div className='h-full w-1 mt-1 bg-customOne'></div>
                                    </div>
                                    <div>
                                        <div className={subTitle} dangerouslySetInnerHTML={{__html: step.instructions}}></div>
                                        <div className='flex text-sm'>
                                            <div>{step.distance.text}</div>
                                            <div>{step.duration.text}</div>
                                        </div>
                                    </div>
                                </div>
                                )
                            }
                        </div>
                    }
                </div>
                <div className='flex gap-4 justify-center items-center py-4 border-b border-gray-300'>
                    <div className={subTitle}>{distance}</div>
                    <div>
                        <img src={carIcon} height={20} width={20} />
                    </div>
                    <div className={subTitle}>{duration}</div>
                </div>
                {
                    clients.length === 0 ?
                    <div className='flex justify-between items-between gap-4 p-4'>
                        <button className={btnRound} onClick={() => props.setShowModal(false)}>
                            <img src={arrowBlack} height={50} width={50} />
                        </button>
                        <button className={btnOne} onClick={() => setShowConfirmationModal(true)}>
                            <div className='flex items-center justify-center cursor-pointer'>
                                <img src={navIcon} height='20px' width='20px' />
                                <span className='ml-2'>Start</span>
                            </div>
                        </button>
                        <div className={btnOne + ' ' + 'cursor-pointer'} onClick={() => setShowMap(!showMap)}>
                            {showMap ? 'Steps' : 'Map'}
                        </div>
                        {/* <div className='py-2 px-8 bg-custom-1 rounded-md text-white text-xl font-semibold font-family-lato-light'>
                            <span>
                                <a href={`https://google.com/maps/@${myLocation.longitude},${myLocation.latitude}`}>GMap</a>
                            </span>
                        </div> */}
                    </div>
                    :
                    <div className='flex justify-between gap-4 px-4'>
                        <button className={btnRound + ' ' + 'cursor-pointer'} onClick={() => props.setShowModal(false)}>
                            <img src={arrowBlack} height={100} width={100} />
                        </button>
                        <button className={btnOne + ' ' + 'cursor-pointer'} onClick={() => stopLocationStreaming()}>Reached</button>
                        <button className={btnOne + ' ' + 'cursor-pointer'} onClick={() => setShowDelayModal(true)}>Delay</button>
                        <button className={btnOne + ' ' + 'cursor-pointer'}  onClick={() => cancelTrip()}>Cancel</button>
                    </div>
                }
            </div>
        </div>
    )
}

export default Map;